"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[935,1550,2303,2362,2703,2773,4982,5383,7065,8569,9822],{

/***/ 935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ elementsExist)
/* harmony export */ });
function elementsExist(elements = []) {
  return elements.filter((el) => el.length).length == elements.length
}


/***/ }),

/***/ 1550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ disableScroll)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function disableScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).addClass('overflow-hidden')
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').addClass('overflow-hidden')
}


/***/ }),

/***/ 2303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ showToastNotification)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function showToastNotification(message, url, status = 'warning') {
  const $toastContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-wishlist-toast-container]')
  const bgColor = {
    success: 'bg-successGreen',
    warning: 'bg-moon',
    error: 'bg-errorPink',
  }

  const $toast = jquery__WEBPACK_IMPORTED_MODULE_0___default().parseHTML(`<div
      class="animate-fadeInUp animate-duration-[800ms] text-base font-galano font-bold text-galaxt leading-none rounded ${
        bgColor[status]
      } shadow-sm py-4 px-5 mx-auto flex items-center justify-center gap-2 transition-all w-full max-w-[calc(100vw_-_32px)] lg:max-w-[600px]"
    >
      ${
        status === 'success'
          ? `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.3333 7L7.75 11.5833L5.66666 9.5" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>      
      `
          : `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1Z" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 5.79996V9.66663" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 12.2H9.01067" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `
      }
      <span>${message}${
    url && url !== '' ? ` - <a href="${url}" class="text-galaxy underline hover:no-underline">View</a></span>` : ''
  }
    </div>`)

  $toastContainer.append($toast)
  const $toastNode = $toastContainer.children().last()

  setTimeout(function () {
    $toastNode.removeClass('animate-fadeInUp').addClass('animate-fadeOutDown')
    setTimeout(function () {
      $toastNode.remove()
    }, 500)
  }, 3500)
}


/***/ }),

/***/ 2362:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ trapFocus)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * * Traps user focus within a wrapper when the wrapper is `active`
 * @param { HtmlElement } wrapper
 *
 * @example
 *  <div data-utility="trap-focus">
 *  ...
 *  </div>
 */

function trapFocus({ wrapper }) {
  const { classes } = window.config

  const state = {
    focusOnReturnEl: undefined, // The element to focus on close
  }

    ; (function init() {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('keydown', handleKeydown)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).onClassChange(classes.active, updateFocus)
    })()

  function handleKeydown(event) {
    const { target, key, shiftKey } = event

    // Comparison is only necesssary if the wrapper is active
    const wrapperIsActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)
    if (!wrapperIsActive) return

    // Handle Escape key to close modal
    if (key === 'Escape') {
      // Trigger a custom event that the modal can listen for
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('modal:close')
      return
    }

    // Handle Tab key for focus trapping
    if (key !== 'Tab') return

    const $focusable = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).findFocusable()
    const $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(target)

    const tabbingOutForwards = $target.is($focusable.last()) && !shiftKey
    const tabbingOutBackwards = $target.is($focusable.first()) && shiftKey

    if (tabbingOutForwards || tabbingOutBackwards) event.preventDefault()

    if (tabbingOutBackwards) $focusable.last().trigger('focus')
    if (tabbingOutForwards) $focusable.first().trigger('focus')
  }

  // Focuses on the correct element when the wrapper changes `active` states
  function updateFocus() {
    const wrapperIsActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)
    const $focusable = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).findFocusable()

    // Set focus on the first focusable element within the wrapper
    if (wrapperIsActive) {
      state.focusOnReturnEl = state.focusOnReturnEl || document.activeElement
      $focusable.first().trigger('focus')
    }

    // Return focus to the element that originally opened the wrapper
    if (!wrapperIsActive && state.focusOnReturnEl) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(state.focusOnReturnEl).trigger('focus')
      state.focusOnReturnEl = undefined
    }
  }
}


/***/ }),

/***/ 2703:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ registryWishlist)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9822);



function registryWishlist() {
  const customerId = document.querySelector('[data-customer-id]')?.dataset?.customerId

  const settings = {
    accountModal: '[data-account-modal]',
    accountOverlay: '[data-account-overlay]',
    accountModalClose: '[data-account-modal-close]',
    pdpRegistryLoginBtn: '[data-pdp-registry-login]',

    addToRegistry: '[data-hook="add-to-registry"]',
    closeEditRegistryModal: '[data-edit-registry-modal-close]',
    closeRegistryAddressModal: '[data-edit-registry-address-modal-close]',
    closeRegistryModal: '[data-registry-modal-close]',
    copyRegistryLink: '[data-copy-registry-link-button]',

    deleteRegistryButton: '[data-delete-registry-btn]',
    deleteRegistryModalButton: '[data-delete-registry-modal-btn]',
    deleteRegistryModalCloseBtn: '[data-delete-registry-modal-close]',
    deleteRegistryModal: '[data-delete-registry-modal]',
    deleteRegistryOverlay: '[data-delete-registry-overlay]',

    editRegistryAddressButton: '[data-edit-registry-edit-address-button]',
    editRegistryAddressForm: '#registry-edit-address-form',
    editRegistryAddressSubmitButton: '[data-edit-registry-address-submit-btn]',
    editRegistryAddressModal: '[data-edit-registry-address-modal]',
    editRegistryAddressOverlay: '[data-edit-registry-address-overlay]',

    editRegistryAddLittleButton: '[data-add-little-button]',
    editRegistryButton: '[data-edit-registry-button]',
    editRegistryLittlesList: '[data-edit-littles-list]',
    editRegistryImageButton: '[data-registry-edit-image-button]',
    editRegistryImageInput: '[data-registry-image-upload-input]',

    editRegistryDetailsButton: '[data-edit-registry-details-btn]',
    editRegistryDetailsCloseButton: '[data-edit-registry-details-modal-close]',
    editRegistryDetailsOpenButton: '[data-edit-registry-details-modal-open]',
    editRegistryDetailsModal: '[data-edit-registry-details-modal]',
    editRegistryDetailsOverlay: '[data-edit-registry-details-overlay]',

    editRegistryDescriptionButton: '[data-edit-registry-description-btn]',
    editRegistryDescriptionCloseButton: '[data-edit-registry-description-modal-close]',
    editRegistryDescriptionOpenButton: '[data-edit-registry-description-modal-open]',
    editRegistryDescriptionModal: '[data-edit-registry-description-modal]',
    editRegistryDescriptionOverlay: '[data-edit-registry-description-overlay]',

    editRegistryModal: '[data-edit-registry-modal]',
    editRegistryTitleButton: '[data-edit-registry-title-btn]',
    editRegistryOverlay: '[data-edit-registry-overlay]',

    editRegistryPasswordModal: '[data-copy-registry-link-modal]',
    editRegistryPasswordOverlay: '[data-copy-registry-link-overlay]',
    editRegistryPasswordCloseButton: '[data-copy-registry-link-modal-close]',
    editRegistryPasswordFormRevealButton: '[data-password-protect-button]',
    editRegistryPasswordModalRevealButton: '[data-open-registry-password-modal-button]',
    editRegistryPasswordHiddenForm: '[data-registry-password-form]',
    editRegistryPasswordInput: '[data-registry-password-input]',
    editRegistryPasswordSaveButton: '[data-save-registry-password-button]',

    emptyRegistryModal: '[data-empty-registry-modal]',
    emptyRegistryModalClose: '[data-empty-registry-modal-close]',
    emptyRegistryOverlay: '[data-empty-registry-overlay]',

    decrementVariant: '[data-registry-variant-decrement]',
    incrementVariant: '[data-registry-variant-increment]',
    variantQuantityInput: '[data-registry-variant-quantity-input]',
    variantAddToCart: '[data-registry-add-to-cart]',

    registryItemDecrement: '[data-registry-item-decrement]',
    registryItemIncrement: '[data-registry-item-increment]',
    registryItemQuantityInput: '[data-registry-item-quantity-input]',

    registryTemplateItemDecrement: '[data-registry-template-item-decrement]',
    registryTemplateItemIncrement: '[data-registry-template-item-increment]',
    registryTemplateItemQuantityInput: '[data-registry-template-item-quantity-input]',
    registryTemplateAddToRegistryButton: '[data-add-template-to-registry-button]',

    registryContainer: '[data-component="registry-wishlist"]',
    registryDescriptionInput: '[data-registry-description-input]',
    registryItemsList: '[data-active-registry-items]',
    registryModalAdded: '[data-added-registry-modal]',
    registryTitleInput: '[data-registry-title-input]',
    registryOverlay: '[data-registry-overlay]',
    registryPage: '[data-active-registry-page]',
    registryPasswordForm: '[data-registry-password-form]',
    registryPasswordInput: '[data-registry-password-input]',
    registryPasswordSection: '[data-registry-password-section]',
    registryPrice: '[data-registry-price]',
    registryVariant: '[data-registry-variant]',
    registryVariantQuantity: '[data-pdp-quantity-input]',
    removeFromRegistry: '[data-hook="remove-from-registry"]',

    shareRegistryButton: '[data-share-registry-button]',

    wishlistModal: '[data-wishlist-modal]',
    openWishlistModal: '[data-hook="wishlist-modal-open"]',
    closeWishlistModal: '[data-wishlist-modal-close]',
    wishlistOverlay: '[data-wishlist-overlay]',
    wishlistSelect: '[data-hook="wishlist-select"]',
    openWishlistSelect: '[data-hook="open-wishlist-select"]',
    currentWishlist: '[data-hook="current-wishlist"]',
    wishlistOptions: '[data-hook="wishlist-options"',
    wishlistOptionButton: '[data-wishlist-option]',
    createWishlistWrapper: '[data-create-wishlist-wrapper]',
    openCreateWishlistForm: '[data-open-create-wishlist-form]',
    createWishlistForm: '[data-create-wishlist-form]',
    createWishlistInput: '[data-create-wishlist-input]',
    createWishlistError: '[data-create-wishlist-error]',
    wishlistVariant: '[data-wishlist-variant]',
    wishlistPrice: '[data-wishlist-price]',
    addToWishlist: '[data-hook="add-to-wishlist"]',
    wishlistLink: '[data-wishlist-link]',
    wishlistLinkName: '[data-wishlist-link-name]',

    registryGroupSwatches: '[data-registry-swatch-button]',
    registryGroupOptions: '[data-registry-option-button]',
  }

  ;(function init() {
    initializeEventListeners()
  })()

  function initializeEventListeners() {
    if ((0,_utilities__WEBPACK_IMPORTED_MODULE_1__.elementsExist)([jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]')])) {
      renderRegistryItemsPrivate()
    }
    if ((0,_utilities__WEBPACK_IMPORTED_MODULE_1__.elementsExist)([jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-public-json]')])) {
      renderRegistryItemsPublic()
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToRegistry).on('click', addVariantToRegistry)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.removeFromRegistry, ($el) => $el.on('click', removeFromRegistry))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.closeEditRegistryModal, ($el) => $el.on('click', closeEditRegistryModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.closeRegistryModal, ($el) => $el.on('click', closeRegistryModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.registryOverlay, ($el) => $el.on('click', closeRegistryModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.copyRegistryLink, ($el) => $el.on('click', copyRegistryLink))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryButton, ($el) => $el.on('click', openEditRegistryModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryOverlay, ($el) => $el.on('click', closeEditRegistryModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryAddLittleButton, ($el) => $el.on('click', editRegistryAddLittle))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryAddressButton, ($el) => $el.on('click', openEditRegistryAddressModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.closeRegistryAddressModal, ($el) => $el.on('click', closeEditRegistryAddressModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryAddressOverlay, ($el) => $el.on('click', closeEditRegistryAddressModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryAddressSubmitButton, ($el) => $el.on('click', editRegistryAddress))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryTitleButton, ($el) => $el.on('click', editRegistryTitle))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryDetailsCloseButton, ($el) => $el.on('click', closeRegistryDetailsModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryDetailsOverlay, ($el) => $el.on('click', closeRegistryDetailsModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryDetailsButton, ($el) => $el.on('click', editRegistryDetails))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryDetailsOpenButton, ($el) => $el.on('click', openRegistryDetailsModal))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.incrementVariant, ($el) => $el.on('click', incrementVariant))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.decrementVariant, ($el) => $el.on('click', decrementVariant))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.deleteRegistryModalButton, ($el) => $el.on('click', openDeleteRegistryModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.deleteRegistryModalCloseBtn, ($el) => $el.on('click', closeDeleteRegistryModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.deleteRegistryOverlay, ($el) => $el.on('click', closeDeleteRegistryModal))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.deleteRegistryButton, ($el) => $el.on('click', deleteRegistry))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryImageButton, ($el) =>
      $el.on('click', () => jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryImageInput).trigger('click'))
    )
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryImageInput, ($el) => $el.on('change', uploadRegistryImage))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryDescriptionOpenButton, ($el) =>
      $el.on('click', openRegistryDescriptionModal)
    )
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryDescriptionCloseButton, ($el) =>
      $el.on('click', closeRegistryDescriptionModal)
    )
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryDescriptionOverlay, ($el) =>
      $el.on('click', closeRegistryDescriptionModal)
    )
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.editRegistryDescriptionButton, ($el) => $el.on('click', editRegistryDescription))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.accountOverlay).on('click', closeAccountModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.accountModalClose).on('click', closeAccountModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpRegistryLoginBtn).on('click', setRegistryIntent)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.emptyRegistryModalClose).on('click', closeEmptyRegistryModal)

    // Escape key handlers for modals
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.accountModal).on('modal:close', function () {
      closeAccountModal()
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.emptyRegistryModal).on('modal:close', function () {
      closeEmptyRegistryModal()
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.emptyRegistryOverlay).on('click', closeEmptyRegistryModal)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openWishlistModal).on('click', openWishlistModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeWishlistModal).on('click', closeWishlistModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistOverlay).on('click', closeWishlistModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openWishlistSelect).on('click', toggleWishlistSelect)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openCreateWishlistForm).on('click', openCreateWishlistForm)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistForm).on('submit', createWishlist)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistOptionButton).on('click', selectWishlist)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToWishlist).on('click', addToWishlist)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.shareRegistryButton, ($el) => $el.on('click', shareRegistry))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.registryItemDecrement, ($el) => {
      $el.on('click', decrementItemQuantity)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.registryItemIncrement, ($el) => {
      $el.on('click', incrementItemQuantity)
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.registryTemplateItemDecrement, ($el) => {
      $el.on('click', decrementTemplateItemQuantity)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.registryTemplateItemIncrement, ($el) => {
      $el.on('click', incrementTemplateItemQuantity)
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordModalRevealButton).on('click', openRegistryPasswordModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordFormRevealButton).on('click', revealPasswordForm)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordCloseButton).on('click', closeRegistryPasswordModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordOverlay).on('click', closeRegistryPasswordModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordSaveButton).on('click', updateRegistryPassword)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryPasswordForm).on('submit', authRegistryPassword)

    // Registry Template
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryGroupSwatches).on('click', selectRegistryGroupSwatch)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryGroupOptions).on('click', selectRegistryGroupOption)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryTemplateAddToRegistryButton).on('click', addTemplateToRegistry)
    if ((0,_utilities__WEBPACK_IMPORTED_MODULE_1__.elementsExist)([jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryTemplateAddToRegistryButton)])) {
      window.addEventListener('load', () => {
        const $groupCards = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-group-card]')
        $groupCards.each(function (index, card) {
          const $activeSwatch = jquery__WEBPACK_IMPORTED_MODULE_0___default()(card).find(`[data-registry-swatch-button].on`)
          setSwatchOptionsOnLoad($activeSwatch)
        })
      })
    }
  }

  function updateRegistryDisplayCount() {
    let desiredCount = 0
    let purchasedCount = 0
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-item-section]').each(function () {
      const $section = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
      let sectionCount = 0
      $section
        .find('[data-registry-items-list]')
        .children()
        .each(function () {
          const $card = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
          const desiredQuantity = parseInt($card.data('variant-quantity-desired'))
          const purchasedQuantity = parseInt($card.data('variant-quantity-purchased'))
          const remainingQuantity = desiredQuantity - purchasedQuantity
          sectionCount += remainingQuantity
          desiredCount += desiredQuantity
          purchasedCount += purchasedQuantity
        })
      $section.find('[data-registry-section-quantity-count]').text(sectionCount)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-total-items]').text(desiredCount)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-purchased-items]').text(purchasedCount)
  }

  function deleteEmptySections() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-item-section]').each(function () {
      const $section = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
      const $itemsList = $section.find('[data-registry-items-list]')
      if ($itemsList.children().length === 0) {
        $section.remove()
      }
    })
  }

  function chunkArray(array, chunkSize) {
    const chunks = []
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize))
    }
    return chunks
  }

  async function renderRegistryItemsPublic() {
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-public-json]').data('registry-public-json')
    const registryData = JSON.parse(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-public-json]').text())
    const registryItems = registryData.items

    // Skip first 20 items (already rendered on page load), process items 21+
    const itemsToFetch = registryItems.slice(20)
    if (itemsToFetch.length === 0) {
      return // No items to fetch
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-id-hidden-input]').val(registryId)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-registrant-email-hidden-input]').val(registryData.registrant_email)

    // Split remaining items into chunks of 20
    const itemChunks = chunkArray(itemsToFetch, 20)

    // Process each chunk sequentially
    for (const chunk of itemChunks) {
      const chunkResults = await Promise.all(
        chunk.map((registryItem) => {
          return new Promise((resolve) => {
            jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax({
              method: 'get',
              url: `/products/${registryItem.product_handle}?sections=registry-card-public-ajax&variant=${registryItem.variant_id}`,
              success: function (response) {
                if (response && response['registry-card-public-ajax']) {
                  const $card = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response['registry-card-public-ajax']).find('[data-registry-variant-card]')
                  $card.data('variant-quantity-desired', registryItem.quantity_desired)

                  // Set registry id on hidden input
                  $card.find('[data-registry-id-hidden-input]').val(registryId)

                  // Set max on quantity input
                  $card
                    .find(settings.variantQuantityInput)
                    .data('registry-variant-quantity-input', registryItem.variant_id)
                    .attr('max', registryItem.quantity_desired - registryItem.quantity_purchased)

                  $card
                    .find(settings.variantQuantityInput)
                    .data('registry-variant-quantity-input', registryItem.variant_id)
                    .val(1)

                  // Set quantity purchased text
                  $card
                    .find('[data-registry-item-quantity-purchased-text]')
                    .text(`${registryItem.quantity_purchased} of ${registryItem.quantity_desired} purchased`)

                  // Set registrant email on hidden input
                  $card.find('[data-registry-registrant-email-hidden-input]').val(registryData.registrant_email)

                  // Set classes and disabled state on atc button and text
                  if (registryItem.quantity_purchased >= registryItem.quantity_desired) {
                    const $atcButton = $card.find('[data-registry-add-to-cart-button]')
                    const $atcText = $atcButton.find('[data-registry-atc-text]')
                    $card
                      .find('[data-registry-item-add-to-cart]')
                      .attr('disabled', true)
                      .addClass('cursor-not-allowed bg-mist')
                      .removeClass('bg-galaxy hover:bg-sky')
                    $atcText.text('Purchased')
                  }

                  // Set encoded address on hidden input
                  const addressParams = new URLSearchParams({
                    'checkout[shipping_address][first_name]': registryData.address_first_name,
                    ...(registryData.address_last_name && {
                      'checkout[shipping_address][last_name]': registryData.address_last_name,
                    }),
                    ...(registryData.address1 && {
                      'checkout[shipping_address][address1]': registryData.address1,
                    }),
                    ...(registryData.address2 && {
                      'checkout[shipping_address][address2]': registryData.address2,
                    }),
                    ...(registryData.city && {
                      'checkout[shipping_address][city]': registryData.city,
                    }),
                    ...(registryData.province_code && {
                      'checkout[shipping_address][province_code]': registryData.province_code,
                    }),
                    ...(registryData.country && {
                      'checkout[shipping_address][country]': registryData.country,
                    }),
                    ...(registryData.zip && {
                      'checkout[shipping_address][zip]': registryData.zip,
                    }),
                  })
                  const encodedAddress = `?${addressParams.toString()}`
                  $card.find('[data-registry-shipping-address-hidden-input]').val(encodedAddress)

                  resolve($card)
                } else {
                  resolve(null) // Resolve with null if no card was created
                }
              },
              error: function () {
                resolve(null) // Resolve with null on error
              },
            })
          })
        })
      )

      // Filter out null results and append to existing sections
      const validCards = chunkResults.filter((node) => node !== null)

      validCards.forEach(($card) => {
        const productType = $card.data('product-type')
        const $existingSection = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-registry-product-type="${productType}"]`).closest(
          '[data-registry-item-public-section]'
        )

        if ($existingSection.length > 0) {
          // Append to existing section
          const $list = $existingSection.find(`[data-registry-items-list="${productType}"]`)
          $list.append($card)

          // Update quantity count
          const $quantityCount = $existingSection.find('[data-registry-section-quantity-count]')
          const currentCount = parseInt($quantityCount.text()) || 0
          const cardQuantity = parseInt($card.data('variant-quantity-desired')) || 0
          $quantityCount.text(currentCount + cardQuantity)
        } else {
          // Create new section for this product type
          const $container = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-items-public-container]')
          const hasExistingSections = $container.find('[data-registry-item-public-section]').length > 0
          const $section = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`
            <div data-registry-item-public-section>
              ${hasExistingSections ? '<div class="h-px w-full bg-sky"></div>' : ''}
              <div class="mb-4 mt-7 flex items-center justify-center gap-2 md:mb-8 md:mt-16 md:justify-start md:gap-3">
                <h3
                  class="m-0 text-center text-3xl font-semibold md:text-4xl"
                  data-registry-product-type="${productType}"
                >
                  ${productType}
                </h3>
                <p
                  class="m-0 text-base leading-[19.2px] md:text-lg md:leading-[21.6px]"
                  data-registry-section-quantity
                >
                  (<span data-registry-section-quantity-count>${$card.data('variant-quantity-desired') || 0}</span>)
                </p>
              </div>
              <ul
                class="m-0 mb-7 flex list-none flex-wrap gap-4 md:mb-12 md:gap-8"
                data-registry-items-list="${productType}"
              ></ul>
            </div>
          `)
          const $list = $section.find('[data-registry-items-list]')
          $list.append($card)
          $container.append($section)
        }
      })
    }
  }

  async function renderRegistryItemsPrivate() {
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').data('registry-private-json')
    const registryData = JSON.parse(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').text())
    const registryItems = registryData.items

    // Skip first 20 items (already rendered on page load), process items 21+
    const itemsToFetch = registryItems.slice(20)

    if (itemsToFetch.length === 0) {
      return // No items to fetch
    }

    // Split remaining items into chunks of 20
    const itemChunks = chunkArray(itemsToFetch, 20)
    const $registryItemsList = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-items-list]')

    // Process each chunk sequentially
    for (const chunk of itemChunks) {
      const chunkResults = await Promise.all(
        chunk.map((registryItem) => {
          return new Promise((resolve) => {
            jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax({
              method: 'get',
              url: `/products/${registryItem.product_handle}?sections=registry-card-ajax&variant=${registryItem.variant_id}`,
              success: function (response) {
                if (response && response['registry-card-ajax']) {
                  const $card = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response['registry-card-ajax']).find('[data-registry-variant-card]')
                  $card
                    .data('registry-variant-card', registryItem.variant_id)
                    .data('variant-quantity-desired', registryItem.quantity_desired)
                    .data('variant-quantity-purchased', registryItem.quantity_purchased)
                  $card.find('[data-hook="remove-from-registry"]').each(function () {
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('variant-id', registryItem.variant_id)
                  })
                  $card
                    .find('[data-registry-variant-decrement]')
                    .data('registry-variant-decrement', registryItem.variant_id)
                    .data('variant-id', registryItem.variant_id)
                  $card
                    .find('[data-registry-variant-increment]')
                    .data('registry-variant-increment', registryItem.variant_id)
                    .data('variant-id', registryItem.variant_id)
                  $card
                    .find(settings.variantQuantityInput)
                    .data('registry-variant-quantity-input', registryItem.variant_id)
                    .val(registryItem.quantity_desired - registryItem.quantity_purchased)
                  $card.find('[data-registry-id-hidden-input]').val(registryId)
                  $card
                    .find('[data-registry-variant-quantity-hidden-input]')
                    .val(registryItem.quantity_desired - registryItem.quantity_purchased)
                  $card
                    .find('[data-registry-item-quantity-purchased-text]')
                    .text(`${registryItem.quantity_purchased}/${registryItem.quantity_desired} purchased`)

                  if (registryItem.quantity_purchased >= registryItem.quantity_desired) {
                    const $atcButton = $card.find('[data-registry-add-to-cart-button]')
                    const $atcText = $atcButton.find('[data-registry-add-to-cart]')

                    $atcButton
                      .attr('disabled', true)
                      .addClass('cursor-not-allowed border-mist bg-mist')
                      .removeClass('border-galaxy bg-mint hover:bg-galaxy')
                    $atcText.text('Purchased')
                  }
                  resolve($card)
                } else {
                  resolve(null) // Resolve with null if no card was created
                }
              },
              error: function () {
                resolve(null) // Resolve with null on error
              },
            })
          })
        })
      )

      // Filter out null results and append to existing list
      const validCards = chunkResults.filter((node) => node !== null)
      $registryItemsList.append(validCards)
    }
  }

  async function addTemplateToRegistry() {
    const $activeTemplate = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-account-page^="registry-template"]:not(.hidden)').first()
    const $productGroups = $activeTemplate.find('[data-registry-template-product-groups]').children()
    const itemsToAdd = []
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-add-template-to-registry-button]').data('add-template-to-registry-button').toString()

    try {
      $productGroups.each(function () {
        const $group = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
        const groupData = JSON.parse($group.find('[data-registry-group-card-data]').text())
        const $checkbox = $group.find('[data-registry-template-custom-checkbox]')
        const checked = $checkbox.prop('checked')

        if (checked) {
          const $optionLists = $group.find('[data-registry-group-option]')
          const options = {}
          $optionLists.each(function () {
            const $selectedOption = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find('[data-registry-option-button].on')
            if ($selectedOption.length === 0) {
              throw Error('Please select sizes for all products!')
            }
            const index = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('registry-group-option-index')
            const value = $selectedOption.data('registry-option-button')
            options[`option${index}`] = value
          })
          const $activeSwatch = $group.find('[data-registry-swatch-button].on').first()
          const product_handle = $activeSwatch.data('registry-swatch-product-handle')
          const product_id = $activeSwatch.data('registry-swatch-button')
          const product = groupData.find((product) => product.id === product_id)
          const variant = product.variants.find((variant) =>
            Object.keys(options).every(
              (key) => variant[key] && variant[key].toLowerCase() === options[key].toLowerCase()
            )
          )

          const variant_id = variant.id

          const quantity_desired = parseInt($group.find('[data-registry-template-item-quantity-input]').val())

          const item = {
            product_handle,
            product_id: product_id.toString(),
            variant_id: variant_id.toString(),
            quantity_desired,
            quantity_purchased: 0,
          }
          itemsToAdd.push(item)
        }
      })
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Adding items to registry...')
      const data = {
        registryId,
        items: itemsToAdd,
      }

      const res = await registryApi.addItemsToRegistry(data)

      if (res.status === 'error') {
        throw Error('An error has occurred.')
      }
      const $registryNavButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-account-nav-button="registry"]')
      $registryNavButton.replaceWith(function () {
        return jquery__WEBPACK_IMPORTED_MODULE_0___default()('<a>', {
          html: jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).html(),
          class: jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('class'),
          href: 'https://littlesleepies.com/account?view=registry',
        }).removeAttr('data-account-nav-button')
      })

      const handle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.copyRegistryLink).data('copy-registry-link-button')
      const url = `https://littlesleepies.com/pages/registry/${handle}`

      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Items added to registry!', url, 'success')
    } catch (e) {
      (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)(e.message, '', 'error')
      console.error({
        location: 'addTemplateToRegistry',
        e,
      })
    }
  }

  function selectRegistryGroupOption() {
    const $option = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $inactiveOptions = $option
      .parents('[data-registry-group-option]')
      .find('[data-registry-option-button]')
      .not($option)

    $option.addClass('on')
    $inactiveOptions.removeClass('on')
  }

  function setSwatchOptionsOnLoad($activeSwatch) {
    const $swatch = $activeSwatch
    const $swatchList = $swatch.parents('[data-registry-group-swatches]')
    const $inactiveSwatches = $swatchList.find('[data-registry-swatch-button]').not($swatch)
    const productId = $swatch.data('registry-swatch-button')
    const productTitle = $swatch.data('registry-swatch-product-title')
    const $groupCard = $swatch.parents('[data-registry-group-card]')
    const data = JSON.parse($groupCard.find('[data-registry-group-card-data]').text())
    const product = data.find((item) => item.id === productId)
    const $title = $groupCard.find('[data-product-group-title]')
    const $activeImageContainer = $groupCard.find(`[data-product-group-image="${productId}"]`)
    const $inactiveImageContainers = $groupCard.find('[data-product-group-image]').not($activeImageContainer)

    $groupCard.find('[data-registry-option-button]').removeClass('on')
    $swatch.addClass('on')
    $inactiveSwatches.removeClass('on')
    $activeImageContainer.removeClass('hidden')
    $inactiveImageContainers.addClass('hidden')
    $title.text(productTitle)

    if (product.options.length === 1) {
      // Single option(likely size), enable/disable option buttons accordingly
      const $optionButtons = $groupCard.find(`[data-registry-option-button]`)
      $optionButtons.each(function () {
        const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
        const optionValue = $button.data('registry-option-button')
        const variant = product.variants.find(
          (variant) => variant.option1.trim().toLowerCase() === optionValue.trim().toLowerCase()
        )

        if (!variant.available) {
          $button.attr('disabled', true)
        }
      })
    } else if (product.options.length > 1) {
      // Multiple options, enable/disable first set of option buttons accordingly
      const firstOption = product.options[0]
      const $firstOptionButtons = $groupCard.find(`[data-registry-option-name="${firstOption}"]`)

      $firstOptionButtons.each(function () {
        const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
        const optionVariants = product.variants.filter(
          (variant) =>
            variant.option1.trim().toLowerCase() === $button.data('registry-option-button').trim().toLowerCase()
        )
        const anyVariantAvailable = optionVariants.some((variant) => variant.available)

        if (!anyVariantAvailable) {
          $button.attr('disabled', true)
        }
      })
    }
  }

  function selectRegistryGroupSwatch() {
    const $swatch = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $swatchList = $swatch.parents('[data-registry-group-swatches]')
    const $inactiveSwatches = $swatchList.find('[data-registry-swatch-button]').not($swatch)
    const productId = $swatch.data('registry-swatch-button')
    const productTitle = $swatch.data('registry-swatch-product-title')
    const $groupCard = $swatch.parents('[data-registry-group-card]')
    const data = JSON.parse($groupCard.find('[data-registry-group-card-data]').text())
    const product = data.find((item) => item.id === productId)
    const $title = $groupCard.find('[data-product-group-title]')
    const $activeImageContainer = $groupCard.find(`[data-product-group-image="${productId}"]`)
    const $inactiveImageContainers = $groupCard.find('[data-product-group-image]').not($activeImageContainer)

    $groupCard.find('[data-registry-option-button]').removeClass('on')
    $swatch.addClass('on')
    $inactiveSwatches.removeClass('on')
    $activeImageContainer.removeClass('hidden')
    $inactiveImageContainers.addClass('hidden')
    $title.text(productTitle)

    if (product.options.length === 1) {
      // Single option(likely size), enable/disable option buttons accordingly
      const $optionButtons = $groupCard.find(`[data-registry-option-button]`)
      $optionButtons.each(function () {
        const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
        const optionValue = $button.data('registry-option-button')
        const variant = product.variants.find(
          (variant) => variant.option1.trim().toLowerCase() === optionValue.trim().toLowerCase()
        )

        if (!variant.available) {
          $button.attr('disabled', true)
        }
      })
    } else if (product.options.length > 1) {
      // Multiple options, enable/disable first set of option buttons accordingly
      const firstOption = product.options[0]
      const $firstOptionButtons = $groupCard.find(`[data-registry-option-name="${firstOption}"]`)

      $firstOptionButtons.each(function () {
        const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
        const optionVariants = product.variants.filter(
          (variant) =>
            variant.option1.trim().toLowerCase() === $button.data('registry-option-button').trim().toLowerCase()
        )
        const anyVariantAvailable = optionVariants.some((variant) => variant.available)

        if (!anyVariantAvailable) {
          $button.attr('disabled', true)
        }
      })
    }
  }

  function authRegistryPassword(e) {
    e.preventDefault()
    const $passwordContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryPasswordSection)
    const $registryContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryContainer)
    const userInput = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryPasswordInput).val()
    const password = window.lockedRegistryPW

    if (userInput !== password) {
      (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Incorrect password, please try again', '', 'error')
      return
    }

    $passwordContainer.addClass('hidden')
    $registryContainer.removeClass('hidden')
  }

  function openRegistryPasswordModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordModal)
    $modal.removeClass('hidden')
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.trapFocus)(settings.editRegistryPasswordModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeRegistryPasswordModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordModal)
    $modal.addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordModal).off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function revealPasswordForm() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordFormRevealButton).addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordHiddenForm).removeClass('hidden')
  }

  async function updateRegistryPassword() {
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    $button.text('Updating...').addClass('btn-disabled-new').removeClass('btn-transparent-new').attr('disabled', true)
    const newPassword = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordInput).val()
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryPasswordModal).data('copy-registry-link-modal')

    try {
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Updating registry password...')
      const res = await registryApi.updateRegistryPassword({
        registryId: `${registryId}`,
        password: newPassword,
      })
      if (res.status === 'error') {
        throw Error('An error has occurred.')
      }
      (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Registry Password Updated!', '', 'success')
      $button
        .text('Save Changes')
        .addClass('btn-transparent-new')
        .removeClass('btn-disabled-new')
        .attr('disabled', false)
      closeRegistryPasswordModal()
    } catch (e) {
      console.error({
        location: 'updateRegistryPassword - error',
        e,
      })
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('An error has occurred, please reach out to a customer service representative', '', 'error')
    }
  }

  function decrementItemQuantity(e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()
    const $input = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(settings.variantQuantityInput)
    const $card = $input.parents('[data-registry-variant-card]')
    const $hiddenInput = $card.find('[data-registry-variant-quantity-hidden-input]')
    const currentQuantity = parseInt($input.val())
    if (currentQuantity > 1) {
      $input.val(currentQuantity - 1)
      $hiddenInput.val(currentQuantity - 1)
    }
  }

  function incrementItemQuantity(e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()
    const $input = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(settings.variantQuantityInput)
    const $card = $input.parents('[data-registry-variant-card]')
    const $hiddenInput = $card.find('[data-registry-variant-quantity-hidden-input]')
    const currentQuantity = parseInt($input.val())
    const max = $input.attr('max')
    if (currentQuantity < max) {
      $input.val(currentQuantity + 1)
      $hiddenInput.val(currentQuantity + 1)
    }
  }

  function decrementTemplateItemQuantity() {
    const $container = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('[data-registry-template-item-quantity-container]')
    const $input = $container.find('[data-registry-template-item-quantity-input]')
    const currentQuantity = parseInt($input.val())

    if (currentQuantity > 1) {
      $input.val(currentQuantity - 1)
    }
  }

  function incrementTemplateItemQuantity() {
    const $container = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('[data-registry-template-item-quantity-container]')
    const $input = $container.find('[data-registry-template-item-quantity-input]')
    const currentQuantity = parseInt($input.val())
    const max = $input.attr('max')

    if (currentQuantity < max) {
      $input.val(currentQuantity + 1)
    }
  }

  function shareRegistry() {
    const url = window.location.href
    navigator.clipboard.writeText(url)
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Link copied to clipboard!', url, 'success')
  }

  function openAccountModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.accountModal)
    $modal.removeClass('hidden').addClass('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeAccountModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.accountModal)
    $modal.addClass('hidden').removeClass('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function setRegistryIntent() {
    // will check for this session storage item when customer creates account to redirect them to /account?view=registry
    sessionStorage.setItem('registry-intent', true)
  }

  function openEmptyRegistryModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.emptyRegistryModal)
    $modal.removeClass('hidden').addClass('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeEmptyRegistryModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.emptyRegistryModal)
    $modal.addClass('hidden').removeClass('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  async function decrementVariant() {
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-modal]').data('edit-registry-modal').toString()
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Updating quantity...')
    const variantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('registry-variant-decrement')
    const $input = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(settings.variantQuantityInput)
    const $card = $input.parents('[data-registry-variant-card]')
    const $hiddenInput = $card.find('[data-registry-variant-quantity-hidden-input]')
    const quantity = parseInt($input.val()) - 1
    const quantityPurchased = $card.data('variant-quantity-purchased')
    const registryData = JSON.parse(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').text())

    const updatedItems = registryData.items
      .map((item) => {
        if (item.variant_id.toString() === variantId.toString()) {
          item.quantity_desired = quantity
        }
        return item
      })
      .filter((item) => item.quantity_desired !== 0)
    const updatedRegistryData = { ...registryData, items: updatedItems }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').text(JSON.stringify(updatedRegistryData))
    const data = {
      registryId: registryId.toString(),
      items: updatedRegistryData.items,
    }

    try {
      await registryApi.updateVariantQuantity(data)
      if (quantity === 0) {
        $input.parents('[data-registry-variant-card]').remove()
      } else {
        $hiddenInput.val(quantity)
        $input.val(quantity)
        $card.data('variant-quantity-desired', quantity)
        $card.find('[data-registry-item-quantity-purchased-text]').text(`${quantityPurchased}/${quantity} purchased`)
      }

      (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Quantity updated successfully!', '', 'success')
      updateRegistryDisplayCount()
      deleteEmptySections()
    } catch (e) {
      console.error({
        location: 'decrementVariant - error',
        e,
      })
    }
  }

  async function incrementVariant() {
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-modal]').data('edit-registry-modal').toString()
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Updating quantity...')
    const variantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('registry-variant-increment')
    const $input = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(settings.variantQuantityInput)
    const $card = $input.parents('[data-registry-variant-card]')
    const $hiddenInput = $card.find('[data-registry-variant-quantity-hidden-input]')
    const quantity = parseInt($input.val()) + 1
    const quantityPurchased = $card.data('variant-quantity-purchased')
    const registryData = JSON.parse(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').text())

    const updatedItems = registryData.items
      .map((item) => {
        if (item.variant_id.toString() === variantId.toString()) {
          item.quantity_desired = quantity
        }
        return item
      })
      .filter((item) => item.quantity !== 0)
    const updatedRegistryData = { ...registryData, items: updatedItems }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').text(JSON.stringify(updatedRegistryData))

    const data = {
      registryId: registryId.toString(),
      items: updatedRegistryData.items,
    }

    try {
      await registryApi.updateVariantQuantity(data)
      $hiddenInput.val(quantity)
      $input.val(quantity)

      $card.data('variant-quantity-desired', quantity)
      $card.find('[data-registry-item-quantity-purchased-text]').text(`${quantityPurchased}/${quantity} purchased`)
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Quantity updated successfully!', '', 'success')
      updateRegistryDisplayCount()
      deleteEmptySections()
    } catch (e) {
      console.error({
        location: 'incrementVariant - error',
        e,
      })
    }
  }

  function openDeleteRegistryModal(e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()
    closeEditRegistryModal()
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.deleteRegistryModal)
    $modal.removeClass('hidden')
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.trapFocus)(settings.deleteRegistryModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeDeleteRegistryModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.deleteRegistryModal)
    $modal.addClass('hidden').off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  async function deleteRegistry() {
    (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Deleting registry...')
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('delete-registry-btn').toString()
    const variants = []
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-variant-card]').each(function (i, el) {
      variants.push(`${jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).data('registry-variant-card')}`)
    })
    const data = {
      registryId,
      variants,
    }

    try {
      const res = await registryApi.deleteRegistry(data)

      if (res.status === 'error') {
        throw new Error('An error has occured, failed to delete registry.')
      }
      (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Registry deleted!', '', 'success')
      location.href = '/'
    } catch (e) {
      console.error({
        location: 'deleteRegistry - error',
        e,
      })
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('An error has occurred, please contact a customer service representative.', '', 'error')
    }
  }

  async function uploadRegistryImage(e) {
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-modal]').data('edit-registry-modal').toString()
    const image = e.target.files[0]

    const createImageVariables = {
      registryId,
      image: {
        file: image,
      },
    }

    try {
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Uploading image...')
      const res = await registryApi.registryImage.create(createImageVariables)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-image]').attr('src', res.image.url)
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)(
        'Image upload successful! The change may take a moment to reflect in your account portal.',
        '',
        'success'
      )
    } catch (error) {
      console.error('Error:', error)
    }
  }

  async function editRegistryAddLittle() {
    const numMap = {
      1: 'One',
      2: 'Two',
      3: 'Three',
      4: 'Four',
      5: 'Five',
      6: 'Six',
      7: 'Seven',
      8: 'Eight',
      9: 'Nine',
      10: 'Ten',
    }
    const $littlesList = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryLittlesList)
    const newLittleNum = $littlesList.children().length + 1
    const nextElText = numMap[newLittleNum]
    const $newLittleEl = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`
      <div data-create-little-container>
        <div class="flex gap-4 items-center mb-5 mt-2">
          <p class="text-base font-galano font-medium leading-[16px] whitespace-nowrap m-0">
            Baby ${nextElText}'s Info
          </p>
          <div class="w-full h-px bg-galaxy"></div>
        </div>

        <div
          class="relative py-3"
        >
          <input
            type="text"
            class="peer w-full rounded border border-solid border-galaxy bg-transparent p-4 text-galaxy placeholder-transparent text-base"
            placeholder="Baby's Name"
            data-add-little-name-input
          >
          <label
            class="absolute left-3 top-3 m-0 -translate-y-1/2 cursor-text bg-pearl p-0 px-[3px] font-galano !text-base font-bold !normal-case !tracking-normal text-galaxy transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:font-medium peer-focus:top-3 peer-focus:font-bold"
          >
            Baby's Name
          </label>
        </div>

        <div class="relative py-3">
          <input
            type="date"
            style="-webkit-appearance: none;"
            pattern="(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))"
            class="w-full rounded border-galaxy border border-solid p-4 font-galano !text-base font-bold !normal-case !tracking-normal text-galaxy min-h-[60px]"
            data-add-little-date-input
          >
          <label
            class="absolute left-3 top-3 m-0 -translate-y-1/2 cursor-text bg-pearl p-0 px-[3px] font-galano !text-base font-bold !normal-case !tracking-normal text-galaxy transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:font-medium peer-focus:top-3 peer-focus:font-bold"
          >
            Baby's Arrival Date
          </label>
        </div>

        <p class="text-base font-galano font-medium text-galaxy my-5">Baby’s Gender*</p>

        <div class="mb-5">
          <input
            class="radio-input sr-only peer"
            type="radio"
            value="Girl"
            data-little-gender-radio
            id="new-little-girl-radio-${newLittleNum}"
            name="new-little-gender-radio-${newLittleNum}"
          >
          <label
            class="radio-label flex items-center gap-2.5 font-galano text-base font-medium text-galaxy peer-checked:font-bold"
            for="new-little-girl-radio-${newLittleNum}"
          >
            <span class="radio-svg"></span>
            Girl
          </label>
        </div>
        <div class="mb-5">
          <input
            class="radio-input sr-only peer"
            type="radio"
            value="Boy"
            data-little-gender-radio
            id="new-little-boy-radio-${newLittleNum}"
            name="new-little-gender-radio-${newLittleNum}"
          >
          <label
            class="radio-label flex items-center gap-2.5 font-galano text-base font-medium text-galaxy peer-checked:font-bold"
            for="new-little-boy-radio-${newLittleNum}"
          >
            <span class="radio-svg"></span>
            Boy
          </label>
        </div>
        <div class="mb-8">
          <input
            class="radio-input sr-only peer"
            type="radio"
            value="Undeclared"
            data-little-gender-radio
            id="new-little-undeclared-radio-${newLittleNum}"
            name="new-little-gender-radio-${newLittleNum}"
          >
          <label
            class="radio-label flex items-center gap-2.5 font-galano text-base font-medium text-galaxy peer-checked:font-bold"
            for="new-little-undeclared-radio-${newLittleNum}"
          >
            <span class="radio-svg"></span>
            Don’t know / prefer not to answer
          </label>
        </div>
      </div>  
      `)
    $littlesList.append($newLittleEl)
    if (newLittleNum >= 4) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryAddLittleButton).remove()
    }
  }

  async function editRegistryDetails() {
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-modal]').data('edit-registry-modal')
    const firstName = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-first-name]').val()
    const lastName = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-last-name]').val()
    const littlesToUpdate = []
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-little-container]').each(function (i, el) {
      const id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).data('edit-little-container')
      const name = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).find('[data-edit-little-name-input]').val()
      const arrivalDate = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).find('[data-edit-little-arrival-date-input]').val()
      const gender = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).find('[data-little-gender]:checked').val()
      const updatedLittleData = {
        id: `${id}`,
        name,
        arrivalDate,
        gender,
      }
      littlesToUpdate.push(updatedLittleData)
    })

    const littlesToCreate = []
    let hasInvalidArrivalDate = false
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-create-little-container]').each(function (i, el) {
      const name = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).find('[data-add-little-name-input]').val()
      const arrivalDate = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).find('[data-add-little-date-input]').val()
      const gender = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).find('[data-little-gender-radio]:checked').val()
      const newLittleData = {
        name,
        arrivalDate,
        gender,
      }
      littlesToCreate.push(newLittleData)
      if (!arrivalDate) {
        hasInvalidArrivalDate = true
      }
    })

    if (hasInvalidArrivalDate) {
      (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Please enter an arrival date for your new little!', '', 'error')
      return
    }

    const data = {
      customerId: customerId.toString(),
      registryId: registryId.toString(),
      firstName: firstName.toString(),
      lastName: lastName.toString(),
      littlesToCreate,
      littlesToUpdate,
    }

    try {
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Updating registry details...')
      const res = await registryApi.updateRegistryDetails(data)

      if (res.status === 'error') {
        throw new Error('An error has occured, failed to update registry details.')
      }
      closeRegistryDetailsModal()
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)(
        'Your changes have been made! They may take a moment to reflect in your account portal.',
        '',
        'success'
      )
    } catch (e) {
      console.error({
        location: 'editRegistryDetails',
        e,
      })
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('An error has occured, please contact a customer service representative.', '', 'error')
    }
  }

  function openRegistryDetailsModal() {
    closeEditRegistryModal()
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryDetailsModal)
    $modal.removeClass('hidden')
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.trapFocus)(settings.editRegistryDetailsModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeRegistryDetailsModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryDetailsModal)
    $modal.addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryDetailsModal).off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-create-little-container]').remove()
  }

  function openRegistryDescriptionModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryDescriptionModal)
    $modal.removeClass('hidden')
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.trapFocus)(settings.editRegistryDescriptionModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeRegistryDescriptionModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryDescriptionModal)
    $modal.addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryDescriptionModal).off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  async function editRegistryDescription() {
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryDescriptionButton)
    $button.text('Updating...').addClass('btn-disabled-new').removeClass('btn-black-new').attr('disabled', true)

    const newDescription = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryDescriptionInput).val()
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-modal]').data('edit-registry-modal')

    const updateDescriptionVariables = {
      description: newDescription.toString(),
      registryId: registryId.toString(),
    }

    try {
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Updating registry description...')
      const res = await registryApi.updateRegistryDescription(updateDescriptionVariables)

      if (res.status === 'error') {
        throw new Error('An error has occured, failed to update registry description.')
      }
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-description-text]').text(newDescription)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-description-container]').removeClass('hidden')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-description-container]').hide()
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Registry description updated!', '', 'success')
      closeRegistryDescriptionModal()
      $button.text('Save Changes').addClass('btn-black-new').removeClass('btn-disabled-new').attr('disabled', false)
    } catch (e) {
      console.error({
        location: 'editRegistryDescription',
        e,
      })
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('An error has occured, please contact a customer service representative.', '', 'error')
    }
  }

  async function editRegistryTitle() {
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryTitleButton)
    $button.text('Updating...').addClass('btn-disabled-new').removeClass('btn-black-new').attr('disabled', true)

    const newTitle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryTitleInput).val()
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-modal]').data('edit-registry-modal')

    const updateTitleVariables = {
      title: newTitle.toString(),
      registryId: registryId.toString(),
    }

    try {
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Updating registry name...')
      const res = await registryApi.updateRegistryTitle(updateTitleVariables)

      if (res.status === 'error') {
        throw new Error('An error has occured, failed to update registry name.')
      }
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-title]').text(newTitle)
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Registry name updated!', '', 'success')
      closeEditRegistryModal()
      $button.text('Save Changes').addClass('btn-black-new').removeClass('btn-disabled-new').attr('disabled', false)
    } catch (e) {
      console.error({
        location: 'editRegistryTitle',
        e,
      })
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('An error has occured, please contact a customer service representative.', '', 'error')
    }
  }

  async function editRegistryAddress(e) {
    e.preventDefault()
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryAddressSubmitButton)
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-modal]').data('edit-registry-modal')
    const addressId = $button.data('edit-registry-address-submit-btn')
    const addressFirstName = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-address-first-name]').val()
    const addressLastName = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-address-last-name]').val()
    const address1 = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-address-1]').val()
    const address2 = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-address-2]').val()
    const city = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-city]').val()
    const state = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-state]').val()
    const country = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-country]').val()
    const zip = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-edit-registry-zip]').val()

    const editAddressVariables = {
      registryId: registryId.toString(),
      addressFirstName: addressFirstName ? addressFirstName.toString() : '',
      addressLastName: addressLastName ? addressLastName.toString() : '',
      address1: address1 ? address1.toString() : '',
      address2: address2 ? address2.toString() : '',
      city: city ? city.toString() : '',
      provinceCode: state ? state.toString() : '',
      country: country ? country.toString() : '',
      zip: zip ? zip.toString() : '',
    }

    $button.text('Updating...').addClass('btn-disabled-new').removeClass('btn-black-new').attr('disabled', true)

    try {
      await Promise.all([
        await jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax({
          type: 'POST',
          url: `/account/addresses/${addressId}`,
          data: jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryAddressForm).serialize(),
        }),
        registryApi.editRegistryAddress(editAddressVariables),
      ])
      await reRenderRegistry()
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Address updated!', '', 'success')
    } catch (e) {
      console.error({
        location: 'editAddress error',
        e,
      })
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('An error has occurred, please contact a customer service representative.', '', 'error')
    } finally {
      closeEditRegistryAddressModal()
    }
  }

  async function reRenderRegistry() {
    try {
      const response = await fetch(location.pathname + '?sections=active-registry-page')
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`)
      }
      const data = await response.json()

      if (data && data['active-registry-page']) {
        const $registryPage = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryPage)
        const $newRegistryPage = jquery__WEBPACK_IMPORTED_MODULE_0___default()(data['active-registry-page']).find('[data-active-registry-page]')

        $registryPage.replaceWith($newRegistryPage)
      }
    } catch (e) {
      console.error({
        location: 'reRenderAddresses - error',
        e,
      })
    }
  }

  function openEditRegistryAddressModal() {
    closeEditRegistryModal()
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryAddressModal)
    $modal.removeClass('hidden')
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.trapFocus)(settings.editRegistryAddressModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeEditRegistryAddressModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryAddressModal)
    $modal.addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryAddressModal).off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function closeEditRegistryModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryModal)
    $modal.addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryModal).off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function openEditRegistryModal() {
    const $modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.editRegistryModal)
    $modal.removeClass('hidden')
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.trapFocus)(settings.editRegistryModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function copyRegistryLink() {
    const handle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.copyRegistryLink).data('copy-registry-link-button')
    const registryUrl = `https://littlesleepies.com/pages/registry/${handle}`
    navigator.clipboard.writeText(registryUrl)
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Link copied to clipboard!', registryUrl, 'success')
  }

  async function removeFromRegistry() {
    (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Removing item from registry...')
    const registryVariantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('variant-id')
    const variantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('variant-id')
    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').data('registry-private-json').toString()
    const registryData = JSON.parse(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').text())
    const items = registryData.items.filter((item) => item.variant_id.toString() !== variantId.toString())
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-private-json]').text(JSON.stringify({ ...registryData, items }))

    const removeItemsVariables = {
      registryVariants: [registryVariantId.toString()],
      items,
      registryId,
    }

    try {
      const res = await registryApi.removeItemsFromRegistry(removeItemsVariables)
      if (res.status === 'error') {
        throw new Error('An error has occurred.')
      }

      (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Item removed from registry!', '', 'success')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('[data-registry-variant-card]').remove()
      updateRegistryDisplayCount()
      deleteEmptySections()
    } catch (e) {
      console.error({
        location: 'removeFromRegistry - error',
        e,
      })
    }
  }

  async function addVariantToRegistry(e) {
    e.preventDefault()
    // Frontend variables
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $buttonText = $button.find('[data-registry-atc-text]')
    const customer = $button.data('customer-logged-in')
    const $selectedVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.pdp-variant-select-label-active')
    const productId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-product-id]').data('registry-product-id')
    const productHandle = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-product-handle]').data('registry-product-handle')
    const selectedVariantTitle = $selectedVariant.text()
    const selectedVariantPrice =
      $selectedVariant.find('input[type="radio"]').length > 0
        ? (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.formatMoney)($selectedVariant.find('input[type="radio"]').data('price'))
        : (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-price]').data('registry-price'))
    const registryData = JSON.parse(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-json]').text())
    if (!customer) {
      openAccountModal()
      return
    }
    registryData.items = registryData.items || []
    // API variables
    const variantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-pdp-hidden-select').val()
    const singleVariantItem = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-selected-variant-id]').length === 1
    let quantity = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-pdp-quantity-input]').val()

    const registryId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-id]').data('registry-id')

    if (!registryId) {
      openEmptyRegistryModal()
      return
    } else if (($selectedVariant.length <= 0 && !singleVariantItem) || !variantId) {
      (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Please select a size!', '', 'error')
      return
    }

    const existingItemIndex = registryData.items.findIndex((item) => item.variant_id === variantId.toString())

    if (existingItemIndex !== -1) {
      registryData.items[existingItemIndex].quantity_desired += parseInt(quantity)
    } else {
      registryData.items.push({
        quantity_desired: parseInt(quantity),
        quantity_purchased: 0,
        variant_id: variantId.toString(),
        product_handle: productHandle.toString(),
        product_id: productId.toString(),
      })
    }

    (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Adding to registry...')
    if (singleVariantItem) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryVariant).parent().remove()
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryVariant).text(selectedVariantTitle)
    }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryPrice).html(selectedVariantPrice)
    $button.addClass('btn-disabled-new').attr('disabled', true)
    $buttonText.text('Adding...')

    const addItemVariables = {
      registryId: registryId.toString(),
      items: registryData.items,
    }

    try {
      const res = await registryApi.addItemToRegistry(addItemVariables)
      if (res.status === 'error') {
        throw new Error('An error has occured, failed to add item to registry/wishlist.')
      }
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-json]').text(JSON.stringify(registryData))
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.removeFromRegistry).data('registry-variant-id', res.registryVariantId).data('variant-id', variantId)
      $button.removeClass('btn-disabled-new').addClass('cursor-not-allowed').attr('disabled', true)
      $buttonText.text('Added to Registry')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryModalAdded).removeClass('hidden')
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.trapFocus)(settings.registryModalAdded)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
      ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)('Item added to registry!', '', 'success')
    } catch (e) {
      console.error('addVariantToRegistry', e)
    }
  }

  function closeRegistryModal() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryModalAdded).addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryModalAdded).off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function openWishlistModal(e) {
    e.preventDefault()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistModal).removeClass('hidden')
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.trapFocus)(settings.wishlistModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')

    let selectedVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.pdp-variant-select-label-active')
    let selectedVariantTitle = selectedVariant.text()
    let selectedVariantPrice = (0,_utilities__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(selectedVariant.find('input[type="radio"]').data('price'))

    if (selectedVariant.length > 0) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistVariant).text(selectedVariantTitle)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistPrice).html(selectedVariantPrice)
    }
  }

  function closeWishlistModal(e) {
    e.preventDefault()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistModal).addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistModal).off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function toggleWishlistSelect(e) {
    e.preventDefault()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openWishlistSelect).toggleClass('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistSelect).toggleClass('open')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistOptions).toggleClass('open')
  }

  function openCreateWishlistForm(e) {
    e.preventDefault()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openCreateWishlistForm).addClass('open')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistForm).addClass('open')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistInput).trigger('focus')
  }

  let wishlistArray = ['favorites']

  function createWishlist(e) {
    e.preventDefault()

    let newWishlistTitle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistInput).val()

    let newWishlistExists = jquery__WEBPACK_IMPORTED_MODULE_0___default().inArray(newWishlistTitle.toLowerCase(), wishlistArray) !== -1

    if (newWishlistExists) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistInput).addClass('error')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistError).removeClass('hidden')
    } else if (newWishlistTitle != '' && !newWishlistExists) {
      wishlistArray.push(newWishlistTitle.toLowerCase())

      let newWishlistButton = createWishlistButton(newWishlistTitle)

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(newWishlistButton).insertBefore(settings.createWishlistWrapper)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(newWishlistButton).on('click', selectWishlist)

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openCreateWishlistForm).removeClass('open')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistForm).removeClass('open')

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistInput).val('').removeClass('error')

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.createWishlistError).addClass('hidden')

      console.log('wishlistArray', wishlistArray)

      return wishlistArray
    }
  }

  function selectWishlist(e) {
    e.preventDefault()

    let currentWishlist = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.currentWishlist).data('value')
    let newWishlistButton = createWishlistButton(currentWishlist)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistOptions).prepend(newWishlistButton)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(newWishlistButton).on('click', selectWishlist)

    let newCurrentWishlist = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).data('value')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.currentWishlist).text(newCurrentWishlist).data('value', newCurrentWishlist)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.currentWishlist).siblings('.checkmark').removeClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistLinkName).text(newCurrentWishlist)
    // to-do: update wishlistLink href when new wishlist is selected
    // $(settings.wishlistLink).attr('href', `${newWishlistURL}`)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).parent().remove()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openWishlistSelect).trigger('click')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToWishlist).text('Add to Wishlist').removeClass('added')
  }

  function createWishlistButton(value) {
    let newWishlistButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()(
      `<li class="w-full mb-0 last:mb-5"><button data-wishlist-option data-value="${value}" class="text-galaxy text-base leading-5 font-medium w-full text-left p-0">${value}</button></li>`
    )

    return newWishlistButton
  }

  function addToWishlist(e) {
    e.preventDefault()

    let currentWishlist = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.currentWishlist).data('value')
    let currentWishlistUrl = '#'
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.currentWishlist).siblings('.checkmark').removeClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openWishlistSelect).removeClass('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistSelect).removeClass('open')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.wishlistOptions).removeClass('open')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToWishlist).text('Added to Wishlist').addClass('added')

    setTimeout(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeWishlistModal).trigger('click')
      setTimeout(function () {
        ;(0,_utilities__WEBPACK_IMPORTED_MODULE_1__.showToastNotification)(`Added to ${currentWishlist}`, currentWishlistUrl, 'success')
      }, 500)
    }, 1000)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openWishlistModal).addClass('on')
  }
}


/***/ }),

/***/ 2773:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const useState = (defaultValue) => {
  let value = defaultValue
  const getValue = () => value
  const setValue = (newValue) => (value = newValue)
  return [getValue, setValue]
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useState);


/***/ }),

/***/ 4982:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ formatMoney)
/* harmony export */ });
function formatMoney(cents) {
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}


/***/ }),

/***/ 5383:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ clickToggle)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * @description
 * * Toggles the 'active' class on a given element on click
 * * Multiple triggers can toggle the active class on a single target
 *
 * @options HTML data properties on "wrapper" element
 * * [data-utility="click-toggle"] { required } - Wrapper element that runs this code
 * * [data-toggle] {required} - Pass query selector for target element
 * * [data-toggle-scroll] {optional} - Pass true to toggle scroll on the target element
 * * [data-handle-document-click] {optional} - Pass true to handle document click outside the wrapper
 */

function clickToggle({ wrapper }) {
  const selectors = {
    target: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle'),
    triggers: `[data-toggle="${jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle')}"]`,
    toggleScroll: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle-scroll'),
    handleDocumentClick: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('handle-document-click'),
  }

  const cache = {
    $targets: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.target),
    $triggers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.triggers).not(wrapper).add(wrapper),
  }

  // TailwindCSS variants representing different states
  const { classes } = window.config

  ;(function initEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click.clickToggle.toggle', toggle)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('toggle:close', close)
    if (selectors.handleDocumentClick === true) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', handleDocumentClick)
    }
  })()

  function handleDocumentClick(event) {
    const $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target)

    // Only close if the click is outside the wrapper
    if (selectors.handleDocumentClick === true && !$target.closest(wrapper).length) {
      close()
    }
  }

  function toggle() {
    const isActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)

    cache.$targets.toggleClass(classes.active, !isActive)
    cache.$triggers.toggleClass(classes.active, !isActive)

    if (selectors.toggleScroll === true) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').toggleClass('no-scroll')
    }
  }

  function close() {
    cache.$targets.removeClass(classes.active)
    cache.$triggers.removeClass(classes.active)
  }
}


/***/ }),

/***/ 7065:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ toggleButtonState)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function toggleButtonState($button, activeClass, text) {
  $button
    .toggleClass(`${activeClass} btn-disabled-new`)
    .text(text)
    .prop('disabled', function (i, v) {
      return !v
    })
}


/***/ }),

/***/ 8569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ enableScroll)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function enableScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).removeClass('overflow-hidden')
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').removeClass('overflow-hidden')
}


/***/ }),

/***/ 9822:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   clickToggle: () => (/* reexport safe */ _click_toggle__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   disableScroll: () => (/* reexport safe */ _disable_scroll__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   elementsExist: () => (/* reexport safe */ _elements_exist__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   enableScroll: () => (/* reexport safe */ _enable_scroll__WEBPACK_IMPORTED_MODULE_6__["default"]),
/* harmony export */   formatMoney: () => (/* reexport safe */ _format_money__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   showToastNotification: () => (/* reexport safe */ _show_toast_notification__WEBPACK_IMPORTED_MODULE_8__["default"]),
/* harmony export */   toggleButtonState: () => (/* reexport safe */ _toggle_button_state__WEBPACK_IMPORTED_MODULE_7__["default"]),
/* harmony export */   trapFocus: () => (/* reexport safe */ _trap_focus__WEBPACK_IMPORTED_MODULE_4__["default"]),
/* harmony export */   useState: () => (/* reexport safe */ _use_state__WEBPACK_IMPORTED_MODULE_3__["default"])
/* harmony export */ });
/* harmony import */ var _click_toggle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5383);
/* harmony import */ var _elements_exist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(935);
/* harmony import */ var _format_money__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4982);
/* harmony import */ var _use_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2773);
/* harmony import */ var _trap_focus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2362);
/* harmony import */ var _disable_scroll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1550);
/* harmony import */ var _enable_scroll__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8569);
/* harmony import */ var _toggle_button_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7065);
/* harmony import */ var _show_toast_notification__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2303);













/***/ })

}]);